import React, { useEffect, useState } from "react";
import BreadCrumbBanner from "../../component/BreadCrumbBanner";
import facilitiesAPI from "../../api/facilitiesApi";

const ArtCraft = () => {
  const [creativeSpace, setCreativeSpace] = useState([]);
  const [creativeActivities, setCreativeActivities] = useState([]);

  useEffect(() => {
    fetchArtRoom();
  }, []);

  const fetchArtRoom = async () => {
    const res = await facilitiesAPI.art_room();

    if (res.code === 200) {
      const result = res.data;
      setCreativeSpace(result["creative-space"] || []);
      setCreativeActivities(result["creative-activities"] || []);
    }
  };

  const spaceInfo = creativeSpace?.[0];
  const activityInfo = creativeActivities?.[0];

  return (
    <>
      {/* BreadCrump Section */}
      <BreadCrumbBanner
        title="Art & Craft Studio"
        backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
      />

      {/* art room */}
      {creativeSpace.length > 0 && (
        <section className="art-room-section bg-light">
          <div className="container">
            <div className="row align-items-center g-5">
              {/* CONTENT */}
              <div className="col-lg-6 animate__animated animate__fadeInRight order-md-1 order-2">
                <span className="mrv-subtitle">{spaceInfo?.subtitle}</span>
                <h2 className="mrv-title">{spaceInfo?.title}</h2>
                <p className="art-room-desc">{spaceInfo?.description}</p>
                <div className="art-room-features">
                  {spaceInfo?.listings?.map((item, index) => (
                    <div className="art-card">
                      <img className="library-icon" src={item?.icon} loading="lazy" />
                      <h6>{item?.listingtitle}</h6>
                      <p>{item?.listingdescription}</p>
                    </div>
                  ))}
                </div>
              </div>
              {/* IMAGE */}
              <div className="col-lg-6 animate__animated animate__fadeInLeft order-md-2 order-1">
                <div className="art-room-image">
                  <img src={spaceInfo?.image} alt="Art Room" loading="lazy" />
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Creative Activities Section */}

      <section className="art-activities-section py-5">
        <div className="container">
          <div className="row text-center mb-4">
            <div className="col-lg-8 mx-auto">
              <h2 className="mrv-title">Creative Activities</h2>
              <p>
                Students participate in a variety of artistic activities that
                encourage imagination, creativity, and self-expression.
              </p>
            </div>
          </div>

          <div className="row g-4">
            {creativeActivities.map((item) => (
              <div className="col-md-4" key={item.id}>
                <div className="art-activity-card">
                  <img
                    src={item?.icon}
                    alt={item?.title}
                    className="mb-3 library-icon"
                  />
                  <h5 className="mrv-heading">{item?.title}</h5>
                  <p>{item?.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default ArtCraft;
